import { render, staticRenderFns } from "./NovelData.vue?vue&type=template&id=5e9385b2&scoped=true"
import script from "./NovelData.vue?vue&type=script&lang=ts"
export * from "./NovelData.vue?vue&type=script&lang=ts"
import style0 from "./NovelData.vue?vue&type=style&index=0&id=5e9385b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9385b2",
  null
  
)

export default component.exports